import React, { CSSProperties } from 'react'
import css from './loader.module.css'

const CircleLoader = ({
  color,
  ringStyle,
  ...props
}: React.SVGProps<HTMLDivElement> & { color?: string; ringStyle?: CSSProperties }) => {
  const rStyle = {
    color: color ?? 'var(--primary)',
    ...(ringStyle || {}),
  }

  return (
    <div {...props} className={css.ring}>
      <div className={css.spinner} style={rStyle}></div>
      <div className={css.spinner} style={rStyle}></div>
      <div className={css.spinner} style={rStyle}></div>
      <div className={css.spinner} style={rStyle}></div>
    </div>
  )
}

export default CircleLoader
